import React, { useState } from 'react';
import { useGetSportsbookBetsQuery } from 'store/gamesApi';
import Pagination from '../pagination/pagination';
import SportsHistoryTable, { SportsbookBetItem } from './sportsHistoryTable';
import styles from './sportsHistory.module.scss';

const SportsHistory: React.FC = () => {
  const [page, setPage] = useState(1);
  const limit = 10;

  const {
    data: response,
    isLoading,
    isFetching,
  } = useGetSportsbookBetsQuery({ page, limit }, { refetchOnMountOrArgChange: true });

  const rawData = response?.data ?? response;
  const items: SportsbookBetItem[] = Array.isArray(rawData)
    ? rawData
    : rawData?.docs || rawData?.items || rawData?.bets || rawData?.tickets || rawData?.data || [];
  const total = rawData?.totalDocs ?? rawData?.total ?? rawData?.count ?? items.length;
  const totalPages = Math.ceil((total || 0) / limit) || 1;

  const loading = isLoading || isFetching;

  return (
    <div className={styles.container}>
      <SportsHistoryTable data={items} loading={loading} limit={limit} />

      {!loading && items.length > 0 && totalPages > 1 && (
        <div className={styles.paginationWrapper}>
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      )}
    </div>
  );
};

export default SportsHistory;
